import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'TrainingData';

const TrainingDataApi: any = baseApi(endpoint);

export default TrainingDataApi;